var map = {
	"./adidas-img1.png": "e888",
	"./adidas-img2.png": "7369",
	"./araymond-img1.png": "299c",
	"./araymond-img2.png": "baf3",
	"./araymond-img3.png": "66a8",
	"./araymond-img4.png": "ff6e",
	"./araymond-img5.png": "e342",
	"./araymond-img6.png": "a7fc",
	"./araymond-img7.png": "c0ef",
	"./araymond-img8.png": "008e",
	"./fedex-gif1.gif": "d1fd",
	"./fedex-gif2.gif": "1a0d",
	"./fedex-img1.png": "5cb4",
	"./fedex-img2.png": "1527",
	"./fedex-img3.png": "3bb3",
	"./fedex-img4.png": "a5bd",
	"./fedex-img5.png": "d71a",
	"./fedex-img6.png": "ef7a",
	"./fedex-video1.mp4": "1eeb",
	"./frico-img1.png": "434d",
	"./frico-img2.png": "547b",
	"./frico-img3.png": "bdd2",
	"./frico-img4.png": "9c8d",
	"./frico-img5.png": "f778",
	"./heinekenthesub-img1.png": "46b2",
	"./heinekenthesub-img2.png": "c31f",
	"./jeudecartesux-img1.png": "3bc2",
	"./jeudecartesux-img2.png": "aed2",
	"./kinder-img1.png": "d942",
	"./kinder-video1.mp4": "284b",
	"./logo.png": "cf05",
	"./noise.png": "fdf5",
	"./opalines-img1.png": "cfc4",
	"./opalines-img2.png": "e825",
	"./trf-img1.png": "0126",
	"./trf-img2.png": "ffe2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";